import type { Payment } from '@/models/registry';
import dayjs from 'dayjs';

type SortDirection = 'asc' | 'desc';

const directionMultiplier = (direction: SortDirection) =>
  direction === 'desc' ? -1 : 1;

function makeCreatedAtComparator(direction: SortDirection = 'desc') {
  return (a: Payment, b: Payment) =>
    directionMultiplier(direction) *
    dayjs(a.created_at).diff(dayjs(b.created_at));
}

function sortPaymentsByCreated(
  payments: Payment[],
  direction: SortDirection = 'asc',
) {
  return [...payments].sort(makeCreatedAtComparator(direction));
}

export const sortPaymentsByCreatedNewest = (p: Payment[]) =>
  sortPaymentsByCreated(p, 'desc');

export const sortPaymentsByCreatedOldest = (p: Payment[]) =>
  sortPaymentsByCreated(p, 'asc');
